<template>
	<div>
		<v-container v-if="missingCourse">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>حصل خطا</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else-if="!isEdit || (isEdit && added)">
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>

			<v-stepper v-model="step" :alt-labels="$vuetify.breakpoint.mdAndDown">
				<v-stepper-header>
					<v-stepper-step
						:editable="consent && step > 0"
						edit-icon="mdi-check"
						:complete="step > 1"
						step="1"
					>
						المعلومات الأساسية
					</v-stepper-step>

					<v-divider></v-divider>

					<!-- <v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 2"
						step="2"
					>
						الوظائف
					</v-stepper-step>

					<v-divider></v-divider> -->

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 3"
						step="3"
					>
						المدن
					</v-stepper-step>

					<v-divider></v-divider>

					<!-- <v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 4"
						step="4"
					>
						بيانات الإتصال
					</v-stepper-step>

					<v-divider></v-divider>-->

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 4"
						step="4"
					>
						المرفقات
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="0">
						<v-form v-model="valid0">
							<v-row dense>
								<v-col cols="12" class="text-center text-h5 pb-4">الإقرار</v-col>
								<v-col cols="12">
									<v-skeleton-loader v-if="!conditions" type="paragraph@2"></v-skeleton-loader>
									<pre v-else>{{ conditions }}</pre>
								</v-col>
								<v-col v-if="conditions" cols="12">
									<v-checkbox
										v-model="consent"
										hide-details="auto"
										label="أقر بأنني قرأت نص الإقرار المذكور أعلاه وأوافق على ذلك"
										:rules="[rules.required]"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid0 || !conditions" @click="step = 1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="1">
						<v-form v-model="valid1">
							<v-row no-gutters>
								<v-col cols="12" md="6" order="2" order-md="1">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.title"
												outlined
												hide-details="auto"
												label="العنوان"
												:rules="[rules.required, rules.maxLength75]"
												counter="75"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.companyName"
												outlined
												hide-details="auto"
												label="اسم الجهة"
												:rules="[rules.required, rules.maxLength75]"
												counter="75"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-checkbox v-model="limited" label="يقفل التسجيل عند إكتمال العدد" hide-details class="mt-0"></v-checkbox>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-menu
												v-model="menu3"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="290px"
											>
												<template #activator="{ on }">
													<v-text-field
														v-model="newRecord.startDate"
														outlined
														hide-details="auto"
														label="تاريخ بداية التسجيل"
														:rules="[rules.required]"
														readonly
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
													v-model="newRecord.startDate"
													@input="menu3 = false"
												></v-date-picker>
											</v-menu>
										</v-col>
										<v-col v-if="!limited" cols="12" md="6" class="pa-2">
											<v-menu
												v-model="menu4"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="290px"
											>
												<template #activator="{ on }">
													<v-text-field
														v-model="newRecord.endDate"
														outlined
														hide-details="auto"
														label="تاريخ نهاية التسجيل"
														:rules="[rules.required, rules.endDateAfterStartDate(newRecord.startDate, newRecord.endDate)]"
														readonly
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
													v-model="newRecord.endDate"
													@input="menu4 = false"
												></v-date-picker>
											</v-menu>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.phoneNumber"
												outlined
												hide-details="auto"
												label="رقم الهاتف (اختياري)"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.email"
												outlined
												hide-details="auto"
												label="البريد الإلكتروني (اختياري)"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.link"
												outlined
												hide-details="auto"
												label="رابط التسجيل (اختياري)"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<app-tiny-mce v-model="newRecord.note" class="px-0 py-0" title="التفاصيل (اختياري)"></app-tiny-mce>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6" order="1" order-md="2">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2 text-center">
											<v-btn-toggle v-model="isPhone">
												<v-btn :value="true">
													<v-icon :left="isPhone">mdi-cellphone</v-icon>
													<span v-if="isPhone">طريقة العرض الطولية</span>
												</v-btn>

												<v-btn :value="false">
													<span v-if="!isPhone">طريقة العرض العرضية</span>
													<v-icon :right="!isPhone">mdi-laptop</v-icon>
												</v-btn>
											</v-btn-toggle>
										</v-col>
										<v-col cols="12" class="pa-2 text-center">
											<v-avatar
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (1)"
												class="mt-1"
											>
											<!-- isPhone ? 1/1.4 : 1.4 -->
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="newRecord.attachment | imgToURL"
													:aspect-ratio="1"
												>
													<v-spacer></v-spacer>
													<!-- isPhone ? 1/1.4 : 1.4 -->
													<v-chip v-if="isEdit" tile style="opacity: 0.5;">الصورة الجديدة</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>

											<v-avatar
												v-if="isEdit"
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (1)"
												class="mt-1"
											>
											<!-- isPhone ? 1/1.4 : 1.4 -->
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="oldCourse.attachment"
													:aspect-ratio="1"
												>
													<v-spacer></v-spacer>
													<!-- isPhone ? 1/1.4 : 1.4 -->
													<v-chip style="opacity: 0.5;" :href="oldCourse.attachment" target="_blank">
														الصورة السابقة
														<v-icon right>mdi-file-eye</v-icon>
													</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>
										</v-col>
										<v-col cols="12" class="pa-2" style="padding-top: 23px !important;">
											<v-file-input
												v-model="newRecord.attachment"
												:rules="isEdit ? [rules.max2mb, rules.optionalImage] : [rules.required, rules.max2mb, rules.optionalImage]"
												accept="image/*"
												show-size
												prepend-inner-icon="mdi-camera"
												prepend-icon
												label="صورة العرض"
												outlined
												hide-details="auto"
											></v-file-input>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center" order="3">
									<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="submitStep1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-form v-model="valid2">
							<v-row no-gutters>
								<template v-for="(job, index) in jobs">
									<v-col :key="index" cols="12" class="pa-2">
										<v-card>
											<v-card-text class="pa-1">
												<v-col cols="12" class="pa-2">
													<v-text-field
														v-model="job.title"
														outlined
														hide-details="auto"
														label="وصف الوظيفة"
														:rules="[rules.required]"
													></v-text-field>
												</v-col>
												<v-col cols="12" class="pa-2">
													<v-textarea
														v-model="job.requirements"
														outlined
														hide-details="auto"
														label="المتطلبات"
														:rules="[rules.required]"
													></v-textarea>
												</v-col>
												
												<v-col class="text-end">
													<v-btn class="mx-1" color="error" @click="removeJob(index)">
														حذف الوظيفة
														<v-icon right>mdi-briefcase-remove</v-icon>
													</v-btn>
												</v-col>
											</v-card-text>
										</v-card>
									</v-col>
								</template>
								<v-col cols="12" class="pa-2">
									<v-btn color="primary" @click="jobs.push({title:'', requirements:''})">
										إضافة وظيفة جديدة
										<v-icon right>mdi-briefcase-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="submitRecord">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="3">
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-select
												v-model="recordCities.country"
												outlined
												hide-details="auto"
												label="الدولة"
												:items="countries"
												item-text="name"
												item-value="countryID"
											></v-select>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-select
												v-model="recordCities.region"
												outlined
												hide-details="auto"
												label="المنطقة"
												:items="regions"
												item-text="name"
												item-value="regionID"
											></v-select>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-autocomplete
												v-model="recordCities.cities"
												outlined
												hide-details="auto"
												label="المدينة"
												:items="cities"
												item-text="name"
												item-value="cityID"
												multiple
												chips
												small-chips
												return-object
											>
												<!-- <template v-if="cities.length" v-slot:prepend-item>
													<v-list-item ripple @click="toggleAll">
														<v-list-item-action>
															<v-icon :color="recordCities.cities > 0 ? 'primary' : ''">{{ icon }}</v-icon>
														</v-list-item-action>
														<v-list-item-content>
															<v-list-item-title>كل المدن</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-divider class="mt-2"></v-divider>
												</template>-->
											</v-autocomplete>
										</v-col>
										<v-col cols="12" class="pa-2 text-center">
											<v-btn
												color="success"
												:loading="loading"
												:disabled="recordCities.cities.length == 0"
												@click="addRecordCities"
											>
												إضافة
												<v-icon right>mdi-plus</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-row no-gutters>
										<v-col v-if="storedRecordCities.length" cols="12" class="pa-2 text-center">
											<div class="pb-3">المدن المختارة</div>
											<v-chip-group v-model="selectedForRemoval" column multiple>
												<template v-for="record in storedRecordCities">
													<v-chip :key="record.cityID" :value="record.cityID" class="ma-1" filter>
														{{ record.name }}
													</v-chip>
												</template>
											</v-chip-group>
										</v-col>
										<v-col v-if="storedRecordCities.length" cols="12" class="pa-2 text-center">
											<v-btn
												color="error"
												:loading="loading"
												:disabled="selectedForRemoval.length == 0"
												@click="removeRecordCities"
											>
												حذف
												<v-icon right>mdi-cancel</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="primary"
										:loading="loading"
										:disabled="storedRecordCities.length == 0"
										@click="step = 4"
									>
										حفظ
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<!-- <v-stepper-content step="4">
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-select
										v-model="newCommunication.type"
										outlined
										hide-details="auto"
										label="نوع الإتصال"
										:items="contactTypes"
										item-value="communicationTypeID"
										item-text="name"
									></v-select>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newCommunication.value"
										outlined
										hide-details="auto"
										label="المعرف"
										class="ltr-content"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-textarea
										v-model="newCommunication.note"
										:rows="3"
										outlined
										hide-details="auto"
										label="ملاحظة (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-textarea>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newCommunication.type || !newCommunication.value"
										@click="addContact"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="step4Headers" :items="communications">
										<template v-slot:item.delete="{ item }">
											<v-tooltip bottom>
												<template v-slot:activator=" {on} ">
													<v-btn icon medium :disabled="loading" v-on="on" @click="deleteCommunication(item.id)">
														<v-icon color="error">mdi-comment-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :loading="loading" @click="step = 5">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>-->

					<v-stepper-content step="4">
						<v-form v-model="valid3">
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.name"
										outlined
										hide-details="auto"
										label="اسم الملف"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.description"
										outlined
										hide-details="auto"
										label="الوصف (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-file-input
										v-model="newAttachment.attachment"
										outlined
										hide-details="auto"
										label="الملف"
										prepend-icon
										prepend-inner-icon="mdi-file-upload"
										:rules="[rules.max2mb]"
										show-size
									></v-file-input>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newAttachment.name || !newAttachment.attachment || !valid3"
										@click="uploadAttachment"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="step5Headers" :items="attachments">
										<template #[`item.attachment`]="{ }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium>mdi-file-download</v-icon>
													</v-btn>
												</template>
												<span>تحميل</span>
											</v-tooltip>
										</template>

										<template #[`item.delete`]="{ item }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium color="red" @click="removeAttachment(item.id)">mdi-file-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" class="mx-2" :loading="loading" @click="submit">حفظ وإرسال</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";
import { addBaseURL } from "@/utils/baseURL";
import appTinyMce from "@/components/AppTinyMCE";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	components: {
		appTinyMce
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "الوظائف الطبية",
					exact: true,
					to: { name: "dashboard-jobs" }
				},
				{
					text: "الإضافة",
					disabled: true
				}
			],
			consent: false,
			loading: false,
			step: 0,
			step4Headers: [
				{ value: "communicationType", text: "نوع الإتصال" },
				{ value: "value", text: "المعرف" },
				{ value: "note", text: "ملاحظة" },
				{ value: "delete", text: "حذف", sortable: false }
			],
			step5Headers: [
				{ text: "اسم الملف", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "فتح الملف", value: "attachment" },
				{ text: "حذف الملف", value: "delete", sortable: false },
			],
			newRecord: {
				title: "",
				companyName: "",
				attachment: null,
				startDate: "",
				endDate: "",
				price: "",
				note: "",
				phoneNumber: "",
				email: "",
				link: null
			},
			recordID: null,
			valid0: false,
			valid1: false,
			valid2: false,
			valid3: false,
			menu3: false,
			menu4: false,
			countries: [],
			regions: [],
			cities: [],
			places: [],
			conditions: null,
			newAttachment: {
				name: null,
				attachment: null,
				description: null
			},
			attachments: [],
			contactTypes: [],
			communications: [],
			newCommunication: {
				value: null,
				type: null,
				note: null
			},
			isPhone: true,

			isEdit: false,
			oldCourse: {},
			missingCourse: false,
			added: false,
			jobs: [], //[{ title: "", requirements: "" }],
			recordCities: {
				region: null,
				country: null,
				cities: []
			},
			limited: false,
			storedRecordCities: [],
			selectedForRemoval: []
		};
	},
	watch: {
		step () {
			this.$vuetify.goTo(0);
		},
		"newCommunication.type"(newVal) {
			if (newVal) {
				var type = this.contactTypes.find(
					com => com.communicationTypeID == this.newCommunication.type
				);
				if (type.initialProfilesPath == null) {
					type.initialProfilesPath = "";
				}
				this.newCommunication.value = "" + type.initialProfilesPath;
			}
		},
		recordID() {
			// this.getContactTypes();
		},
		communications() {
			this.contactTypes = [];
			this.getContactTypes();
		},
		"recordCities.country"(newVal) {
			this.recordCities.region = null;
			this.regions = [];
			this.getRegionsForRecordCities(newVal);
		},
		"recordCities.region"(newVal) {
			this.recordCities.cities = [];
			this.cities = [];
			this.getCitiesForRecordCities(newVal);
		}
	},
	mounted() {
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.recordID = this.$route.params.recordID;
			this.consent = true;
			this.step = 1;
		} else {
			console.log("not edit");
		}

		if (!this.isEdit) {
			this.getConditions();
		}
		this.getCountries();

		if (this.isEdit) {
			this.getPreviousInfo();
		}
	},
	methods: {
		getPreviousInfo() {
			client
				.get("/api/jobs/show/" + this.recordID)
				.then(response => {
					console.log(response);
					var newData = response.data.data[0];
					newData.coverPic = addBaseURL(newData.coverPic);

					if(newData.attachments) {
						newData.attachments = newData.attachments.map(att => {
							att.path = addBaseURL(att.path);
							if (att.description == "null") {
								att.description = null;
							}

							return att;
						});
					} else {
						newData.attachments = []
					}

					if(newData.communications) {
						newData.communications = newData.communications.map(
							comm => {
								if (comm.note == "null") {
									comm.note = null;
								}

								if (comm.name == "Telephone") {
									comm.value = "tel:" + comm.value;
								} else if (comm.name == "رقم الجوال") {
									comm.value = "tel:" + comm.value;
								} else if (comm.name == "البريد الإلكتروني") {
									comm.value = "mailto:" + comm.value;
								}
								return comm;
							}
						);
					} else {
						newData.communications = []
					}

					this.newRecord = newData;

					if (this.newRecord.price == 0) {
						this.feeType = "free";
					} else if (this.newRecord.price == -1) {
						this.feeType = "hidden";
					} else {
						this.feeType = "with";
					}

					if (this.chairsLimit == 0) {
						this.chairsLimitType = "free";
					} else if (this.chairsLimit == -1) {
						this.chairsLimitType = "hidden";
					} else {
						this.chairsLimitType = "with";
					}

					if (this.newRecord.attachments) {
						this.attachments = this.newRecord.attachments;
					}

					if (this.newRecord.communications) {
						this.communications = this.newRecord.communications.map(
							e => {
								e.communicationType = e.name;
								return e;
							}
						);
					}

					if (newData.endDate == "1994-11-23"){
						this.limited = true;
						newData.endDate = null
					}

					if (newData.cities) {
						this.storedRecordCities = newData.cities;
					}

					this.oldCourse = { ...newData };
					this.oldCourse.attachment = this.oldCourse.coverPic;

					this.selectedSpecialties = newData.specialties;
					this.added = true;
					setTimeout(() => {
						// on next tick, 0ms is enough
						this.valid1 = true;
					}, 100);
				})
				.catch(err => {
					this.missingCourse = true;
					console.log(err);
				});
		},
		getConditions() {
			client
				.get("/api/jobs/getConditions")
				.then(response => {
					this.conditions = response.data;
					this.conditions = this.conditions || "...";
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCountries() {
			client
				.get("/api/location/countries")
				.then(response => {
					this.countries = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPlaces(cityID) {
			client
				.get("/api/location/cityplaces/" + cityID)
				.then(response => {
					this.places = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitStep1() {
			// this.step = 2;
			this.submitRecord();
		},
		submitRecord() {
			this.loading = true;
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			var data = new FormData();
			data.append("title", this.newRecord.title);
			data.append("companyName", this.newRecord.companyName);
			data.append("startDate", this.newRecord.startDate);
			if (this.limited) {
				data.append("endDate", "1994-11-23");
			} else {
				data.append("endDate", this.newRecord.endDate);
			}
			data.append("email", this.newRecord.email);
			data.append("phoneNumber", this.newRecord.phoneNumber);

			if (this.newRecord.attachment) {
				data.append("attachment", this.newRecord.attachment);
			}

			if (this.newRecord.note) {
				data.append("note", this.newRecord.note);
			}

			if (this.newRecord.link) {
				data.append("link", this.newRecord.link);
			}

			data.append("jobs", JSON.stringify(this.jobs));

			if (this.isEdit) {
				data.append("jobID", this.recordID);
				client
					.post("/api/jobs/update", data, config)
					.then(response => {
						this.step = 3;
						console.log(response);
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				clientNotifier
					.post("/api/jobs/insert", data, config)
					.then(response => {
						this.step = 3;
						this.recordID = response.data.data.id;
						this.isEdit = true;
						this.added = true;
						console.log(response);
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		uploadAttachment() {
			this.loading = true;
			var data = new FormData();
			data.append("jobID", this.recordID);
			data.append("name", this.newAttachment.name);
			data.append("description", this.newAttachment.description);
			data.append("attachment", this.newAttachment.attachment);

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			client
				.post("/api/jobs/addAttachment", data, config)
				.then(response => {
					var insertedAttachment = { 
						id: response.data.data.id,
						name: response.data.data.name,
						description: response.data.data.description,
						attachment: addBaseURL(response.data.data.path),
					};
					this.attachments.push(insertedAttachment);
					this.newAttachment = {
						name: null,
						description: null,
						attachment: null
					};
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getContactTypes() {
			this.contactTypes = [];
			
			client
				.get("/api/jobs/allowconntype/" + this.recordID)
				.then(response => {
					this.contactTypes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addContact() {
			this.loading = true;
			var data = new FormData();
			data.append("relatedID", this.recordID);
			data.append("communicationTypeID", this.newCommunication.type);
			data.append("value", this.newCommunication.value);
			data.append("note", this.newCommunication.note);

			client
				.post("/api/jobs/newcommunication", data)
				.then(response => {
					var type = this.contactTypes.find(
						com =>
							com.communicationTypeID ==
							this.newCommunication.type
					);
					this.communications.push({
						...this.newCommunication,
						communicationType: type.name,
						id: response.data
					});
					this.newCommunication = {
						value: null,
						type: null,
						note: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		deleteCommunication(comID) {
			this.loading = true;

			client
				.delete("/api/communication/delete/" + comID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.communications.findIndex(
						com => com.id == comID
					);
					this.communications.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		submit() {
			this.loading = true;
			client
				.post("/api/jobs/submit/" + this.recordID)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ والإرسال"
					});
					this.$router.push({ name: "dashboard-jobs-manage" });
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addRequirement(job) {
			var requirement = job.newRequirement;
			if (requirement) {
				if (requirement.trim()) {
					job.requirements.push(requirement);
					job.newRequirement = "";
				}
			}
		},
		removeJob(index) {
			this.jobs.splice(index, 1);
		},
		getRegionsForRecordCities(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then(response => {
					this.regions = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCitiesForRecordCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then(response => {
					this.cities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addRecordCities() {
			this.loading = true;

			var data = {
				jobID: this.recordID,
				citiesID: this.recordCities.cities.map(c => c.cityID)
			};

			client
				.post("/api/jobs/addCities", data)
				.then(response => {
					console.log(response);
					var ids = this.storedRecordCities.map(c => c.cityID);
					this.recordCities.cities.forEach(city => {
						if (ids.indexOf(city.cityID) == -1) {
							this.storedRecordCities.push(city);
						}
					});
					this.recordCities.cities = [];

				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		removeRecordCities() {
			this.loading = true;

			this.selectedForRemoval.forEach(cityToBeRemoved => {
				client
					.post("/api/jobs/removeCity/" + this.recordID + "/" + cityToBeRemoved)
					.then(response => {
						console.log(response);
						this.storedRecordCities = this.storedRecordCities.filter(
							city => cityToBeRemoved != city.cityID
						);
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		removeAttachment(attachmentID){
			this.loading = true;

			client
				.delete("/api/attachment/delete/" + attachmentID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.attachments.findIndex(
						attachment => attachment.id == attachmentID
					);
					this.attachments.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.ltr-content ::v-deep input {
	direction: ltr;
}
</style>